module.exports = require("react-native/Libraries/Utilities/HMRClient");
